import React from 'react';
import { 
  Typography, 
  Divider, 
  Grid, 
  Paper, 
  Box
} from "@mui/material";
import {
  Science,
  Badge,
  Label,
  LocationOn,
  Checklist,
  Flag,
  Add,
  Schedule
} from '@mui/icons-material';

const ViewEtkKitJson = ({ etkKit }) => {
  if (!etkKit) {
    return null;
  }

  const InfoItem = ({ icon: Icon, label, value }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
      <Icon sx={{ color: 'primary.main', fontSize: 18, mt: 0.2 }} />
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" color="text.secondary" component="span" sx={{ mr: 0.5 }}>
          {label}:
        </Typography>
        <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>
          {value || 'N/A'}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Paper elevation={0} sx={{ p: 2, border: '1px solid', borderColor: 'divider' }}>
      <Box sx={{ mb: 1.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
          ETK Kit Information
        </Typography>
      </Box>
      <Divider sx={{ mb: 1.5 }} />

      {/* First Row - Equal 4-column layout */}
      <Grid container spacing={1.5} sx={{ mb: 1 }}>
        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Science}
            label="Number of Samples"
            value={etkKit.numberOfSamples}
          />
        </Grid>
        
        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Badge}
            label="Name From Site"
            value={etkKit.nameFromSite}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Label}
            label="Kit Type"
            value={etkKit.vlpName}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={LocationOn}
            label="Sample Location"
            value={etkKit.sampleLocation}
          />
        </Grid>
      </Grid>

      {/* Second Row - Equal 4-column layout */}
      <Grid container spacing={1.5} sx={{ mb: 1 }}>
        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Checklist}
            label="Sample Slate"
            value={etkKit.sampleSlate?.join(', ')}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Flag}
            label="Priority"
            value={etkKit.priority}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Add}
            label="Other Tests to Add"
            value={etkKit.otherTestsToAdd?.join(', ')}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Schedule}
            label="Turn Around Time"
            value={etkKit.turnAroundTime}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewEtkKitJson;